(function () {
  'use strict';

  angular.module('ringbaPortal').component('draftOfferBox', {
    bindings: {
      campaignId: '<',
      campaignCountry: '<',
      publishedOffer: '<',
      draftOffer: '<',
      focusForm: '<',
      editDraft: '<',
      focusDraftForm: '&',
      onCampaignOfferChange: '&',
      onEditCancelled: '&'
    },
    controller: DraftOfferBoxController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/offer/draft-offer-box/draft-offer-box.view.html'
  });

  function DraftOfferBoxController(
    $filter,
    $scope,
    $uibModal,
    accountsService,
    offersService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.showDraftForm = showDraftForm;
    vm.hideDraftForm = hideDraftForm;
    vm.onSaveDraft = onSaveDraft;
    vm.saveAndPublishConfirm = saveAndPublishConfirm;
    vm.publishOffer = publishOffer;
    vm.discardDraft = discardDraft;
    vm.cancelModal = cancelModal;

    function showDraftForm() {
      vm.editDraft.edit = true;
      vm.focusDraftForm();
    }

    function hideDraftForm() {
      vm.editDraft.edit = false;

      if(vm.onEditCancelled)
        vm.onEditCancelled();
    }

    function onSaveDraft() {
      hideDraftForm();
      vm.onCampaignOfferChange();
    }

    function saveAndPublishConfirm() {
      vm.publishConfirmationMessage = $filter('translate')('OFFER_NEW_PUBLISH_CONFIRMATION');
      if (vm.publishedOffer) {
        vm.publishConfirmationMessage = $filter('translate')('OFFER_NEW_REVISION_PUBLISH_CONFIRMATION');
      }
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/offer/publish-offer-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function publishOffer() {
      return offersService.saveDraftOffer(accountsService.currentAccountId, vm.campaignId, vm.draftOffer).then(function() {
        return offersService.publishDraftOffer(accountsService.currentAccountId, vm.campaignId);
      }).then(function() {
        toaster.pop('success', $filter('translate')('OFFER_PUBLISH_SUCCESS'));
        cancelModal();
        vm.onCampaignOfferChange();
      }).catch(utils.errorHandler);
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function discardDraft() {
      return offersService.deleteDraftOffer(accountsService.currentAccountId, vm.campaignId).then(function() {
        toaster.pop('success', $filter('translate')('OFFER_DRAFT_DISCARD_SUCCESS'));
        hideDraftForm();
        vm.onCampaignOfferChange();
      }).catch(utils.errorHandler);
    }


  }
})();
